import styled from 'styled-components';

export const BackDrop = styled.div`
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(0.25rem);
  -webkit-backdrop-filter: blur(0.25rem);
  z-index: 3;
`;

export const Container = styled.div`
  position: relative;
  background-color: #ffffff;
  border-radius: 1rem;
  overflow: hidden;
  margin: 0 1rem;
`;

export const Header = styled.div`
  color: #ffffff;
  background-color: ${({ color }) => color || '#ffffff'};
  text-align: center;
  font-size: 1.7em;
  font-weight: 700;
  padding: 0.8rem 0 0.5rem;
  @media (max-width: 500px) {
    font-size: 1.5em;
    white-space: break-spaces;
  }
`;

export const CloseButton = styled.div`
  position: absolute;
  top: 10px;
  right: 15px;
  font-size: 1.5em;
  font-weight: 600;
  transition: 0.2s;
  cursor: pointer;
  &:after {
    content: 'X';
  }
  &:hover {
    transform: scale(1.2);
  }
`;

export const Content = styled.div`
  padding: 1.5rem 2rem;
`;
